import { useState } from 'react';

type ModalType = 'about' | 'contact' | 'solutions' | 'resources' | 'privacy';

export const useModal = () => {
  const [activeModal, setActiveModal] = useState<ModalType | null>(null);

  const openModal = (modalType: ModalType) => {
    setActiveModal(modalType);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  const isOpen = (modalType: ModalType) => {
    return activeModal === modalType;
  };

  return {
    activeModal,
    openModal,
    closeModal,
    isOpen
  };
};
